<template>
  <div
    class="rule-wrap"
    v-loading="isLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="rule-sec-tit">规则设置
      <div class="rightBtn"> <el-link class="edit-btn" size="mini" type="primary" plain @click="toExplain">查看名词解释>> </el-link></div>
    </div>


    <!-- 销售商付款给平台周期设置 -->
    <div class="rule-sec-wrap">
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          销售商付款给平台周期设置
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop1 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          从
          <span class="light">{{ruleObj.dealer_bill_start_date}}</span>开始
          每间隔
          <span class="light">{{ruleObj.dealer_bill_interval}}</span> 天,
          进行自动结算一次，形成销售商对平台付款的账单。
        </div>
      </div>

      <!-- 平台给供应商结账周期设置 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          平台给供应商结账周期设置
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop2 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          从系统上线开始每间隔
          <span class="light">{{ruleObj.supplier_transfer_interval}}</span> 天,
          进行自动结款一次，形成并推送平台对供应商结账的账单。
        </div>
      </div>

      <!-- 供应商同意锁仓，销售商需下单时间设置 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          供应商同意锁仓，销售商需下单时间设置
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop3 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          当销售商发起锁仓请求，供应商同意后，销售商需要在
          <span class="light">{{ruleObj.order_reserve_period}}</span> 小时内进行下单。
          如果逾时未下单，则系统自动按照一定百分比进行自动核销、发送账单
        </div>
      </div>

      <!-- 供应商同意锁仓，销售商逾时下单自动核销数量比例设置 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          供应商同意锁仓，销售商逾时下单自动核销数量比例设置
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop4 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          当销售商发起锁仓请求，供应商同意后，销售商需要在规定时间内未进行下单，系统按照供应商同意锁仓总数的
          <span
            class="light"
          >{{ruleObj.order_reserve_auto_establish}}</span> %
          进行自动核销，发送付款账单。
        </div>
      </div>

      <!-- 销售商发起锁仓，供应商不操作该锁仓单，多久失效时间设置 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          销售商发起锁仓，供应商不操作该锁仓单，多久失效时间设置
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop5 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          当销售商发起锁仓请求，供应商一直未对该锁仓单进行操作，该锁仓单
          <span class="light">{{ruleObj.order_reserve_expire}}</span> 天后该锁仓单失效。
        </div>
      </div>

      <!-- 平台收取供应服务费用比例设置 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          平台收取供应服务费用比例设置
          <small class="small">（以供应商的实际分佣为基数）</small>
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop6 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          平台收取供应商服务费用为供应商实际所收佣金的
          <span class="light">{{ruleObj.global_service_charge_100}}</span> %。
        </div>
      </div>

      <!-- 商品改价时间限制规则 -->
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          商品改价时间限制规则
          <el-button class="edit-btn" size="mini" type="primary" plain @click="pop7 = true" v-show="function_editRule">修改</el-button>
        </div>
        <div class="rule-item-content">
          第一次允许改价时间为商品上传满
          <span class="light">{{ruleObj.supplier_first_update_item_price}}</span>天，
          第二次及以后的改价需满足距离前一次改价时间满
          <span
            class="light"
          >{{ruleObj.supplier_update_item_price}}</span>天。
        </div>
      </div>
    </div>

    <!-- 按时间进度自动核销规则 -->
    <div class="rule-sec-wrap mul">
      <div class="rule-item-wrap">
        <div class="rule-item-tit">
          按时间进度自动核销规则
          <small class="small">（其中百分比的是基于下单的总数）</small>
        </div>
        <div class="rule-item-content">
          <div v-for="(item, index) in order_auto_establish_rules" :key="index">
            <span class="line">
              销售商下单后第
              <span class="light">{{item[0]}}</span>天
              如果未进行大于等于
              <span class="light">{{item[1]}}</span>
              % 的核销，
              则系统自动按照{{item[1]}}%的差值进行自动核销，并发送账单；
            </span>
            <el-button size="mini" type="primary" plain @click="edit8(item, index)" v-show="function_editRule">修改</el-button>
            <el-popconfirm
              confirmButtonText='确定'
              cancelButtonText='取消'
              icon="el-icon-info"
              iconColor="red"
              title="确定删除这条规则吗？"
              @onConfirm="del8(item, index)"
            >
              <el-button slot="reference" size="mini" type="danger" plain v-show="function_editRule">删除</el-button>
            </el-popconfirm>

          </div>
        </div>
        <div class="add-btn">
          <el-button size="small" type="primary" @click="add8" v-show="function_editRule">新增条件</el-button>
        </div>
      </div>
    </div>

    <!-- !!!!!!!!!!!!!!!!!!!!!!   以下是弹框  !!!!!!!!!!!!!!!!!!!!!!!!! -->

    <!-- 销售商付款给平台周期设置 -->
    <el-dialog
      title="销售商付款给平台周期设置"
      :visible.sync="pop1"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form1" class="dialog-from-wrap">
        从
        <el-date-picker
          class="ipt-date"
          v-model="form1.dealer_bill_start_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>开始 每间隔
        <el-input class="ipt-number" v-model.number="form1.dealer_bill_interval" placeholder="正整数"></el-input>天,
        进行自动结算一次，形成销售商对平台付款的账单。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop1 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm1">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 平台给供应商结账周期设置 -->
    <el-dialog
      title="平台给供应商结账周期设置"
      :visible.sync="pop2"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form2" class="dialog-from-wrap">
        从系统上线开始每间隔
        <el-input
          class="ipt-number"
          v-model.number="form2.supplier_transfer_interval"
          placeholder="正整数"
        ></el-input>天,
        进行自动结款一次，形成并推送平台对供应商结账的账单。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm2">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 供应商同意锁仓，销售商需下单时间设置 -->
    <el-dialog
      title="供应商同意锁仓，销售商需下单时间设置"
      :visible.sync="pop3"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form3" class="dialog-from-wrap">
        当销售商发起锁仓请求，供应商同意后，销售商需要在
        <el-input class="ipt-number" v-model.number="form3.order_reserve_period" placeholder="正整数"></el-input>小时内进行下单。
        如果逾时未下单，则系统自动按照一定百分比进行自动核销、发送账单
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop3 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm3">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 供应商同意锁仓，销售商逾时下单自动核销数量比例设置 -->
    <el-dialog
      title="供应商同意锁仓，销售商逾时下单自动核销数量比例设置"
      :visible.sync="pop4"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form4" class="dialog-from-wrap">
        当销售商发起锁仓请求，供应商同意后，销售商需要在规定时间内未进行下单，系统按照供应商同意锁仓总数的
        <el-input
          class="ipt-number"
          v-model.number="form4.order_reserve_auto_establish"
          placeholder="正整数"
        ></el-input>%
        进行自动核销，发送付款账单。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop4 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm4">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 销售商发起锁仓，供应商不操作该锁仓单，多久失效时间设置 -->
    <el-dialog
      title="销售商发起锁仓，供应商不操作该锁仓单，多久失效时间设置"
      :visible.sync="pop5"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form5" class="dialog-from-wrap">
        当销售商发起锁仓请求，供应商一直未对该锁仓单进行操作，该锁仓单
        <el-input class="ipt-number" v-model.number="form5.order_reserve_expire" placeholder="正整数"></el-input>天后该锁仓单失效。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop5 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm5">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 平台收取供应服务费用比例设置 -->
    <el-dialog
      title="平台收取供应服务费用比例设置"
      :visible.sync="pop6"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form6" class="dialog-from-wrap">
        平台收取供应商服务费用为供应商实际所收佣金的
        <el-input
          class="ipt-number"
          v-model.number="form6.global_service_charge_100"
          placeholder="正整数"
        ></el-input>%。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop6 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm6">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 商品改价时间限制规则 -->
    <el-dialog title="商品改价时间限制规则" :visible.sync="pop7" width="800px" :close-on-click-modal="false">
      <el-form :model="form7" class="dialog-from-wrap">
        第一次允许改价时间为商品上传满
        <el-input
          class="ipt-number"
          v-model.number="form7.supplier_first_update_item_price"
          placeholder="正整数"
        ></el-input>天，
        第二次及以后的改价需满足距离前一次改价时间满
        <el-input
          class="ipt-number"
          v-model.number="form7.supplier_update_item_price"
          placeholder="正整数"
        ></el-input>天。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop7 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm7">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 按时间进度自动核销规则 -->
    <el-dialog
      :title="form8.type == 1 ? '按时间进度自动核销规则新增' : '按时间进度自动核销规则编辑'"
      :visible.sync="pop8"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form8" class="dialog-from-wrap">
        销售商下单后第
        <el-input class="ipt-number" v-model.number="form8.days" placeholder="正整数"></el-input>天
        如果未进行大于等于
        <el-input class="ipt-number" v-model.number="form8.rate" placeholder="正整数"></el-input>
        % 的核销，
        则系统自动按照{{form8.rate}}%的差值进行自动核销，并发送账单
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop8 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm8">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, api } from "@/common/request.js";
import { accMul, validateNumber } from "@/common/tool.js";
import {        utils    } from '@/common/common.js'
import NP from 'number-precision'
export default {
  name: "platformRuleList",
  data() {
    return {
      isLoading: false,
      ruleList: [],
      ruleObj: {
        global_fee_splitting: "",
        global_service_charge: "",
        global_service_charge_100: "",
        dealer_bill_start_date: "",
        dealer_bill_interval: "",
        supplier_transfer_interval: "",
        order_reserve_period: "",
        order_reserve_auto_establish: "",
        order_reserve_expire: "",
        supplier_first_update_item_price: "",
        supplier_update_item_price: "",
        order_auto_establish_rules: ""
      },
      order_auto_establish_rules: [],

      pop1: false,
      form1: {
        dealer_bill_start_date: "",
        dealer_bill_interval: ""
      },

      pop2: false,
      form2: {
        supplier_transfer_interval: ""
      },

      pop3: false,
      form3: {
        order_reserve_period: ""
      },

      pop4: false,
      form4: {
        order_reserve_auto_establish: ""
      },

      pop5: false,
      form5: {
        order_reserve_expire: ""
      },

      pop6: false,
      form6: {
        global_service_charge: "",
        global_service_charge_100: ""
      },

      pop7: false,
      form7: {
        supplier_first_update_item_price: "",
        supplier_update_item_price: ""
      },

      pop8: false,
      form8: {
        type: "", // 1 - 新增  2 - 编辑
        index: "",
        days: "",
        rate: ""
      }
    };
  },
  computed:{
    function_editRule() {
      return utils.getCurrentFunction().indexOf("editRule")>-1
    },
  },
  created() {
    this.getRuleList();
  },
  methods: {
    toExplain(){
      this.$router.push("/rule/explain")
    },
    // 获取配置列表
    getRuleList() {
      this.isLoading = true;
      ajaxPost("/config/getConfigList", {})
        .then(res => {
          this.isLoading = false;
          console.log(res);
          if (res.errorCode == 200) {
            let list = res.data;
            this.ruleList = list;
            if (list && Array.isArray(list)) {
              list.forEach(v => {
                this.ruleObj[v.config_name] = v.config_value;
              });
            }
            this.ruleObj.global_service_charge_100 = accMul(
              this.ruleObj.global_service_charge,
              100
            );

            let order_auto_establish_rules = this.ruleObj.order_auto_establish_rules.split(
              "#"
            );
            this.order_auto_establish_rules = order_auto_establish_rules.map(
              item => {
                return item.split(",");
              }
            );

            this.form1.dealer_bill_start_date = this.ruleObj.dealer_bill_start_date;
            this.form1.dealer_bill_interval = this.ruleObj.dealer_bill_interval;

            this.form2.supplier_transfer_interval = this.ruleObj.supplier_transfer_interval;

            this.form3.order_reserve_period = this.ruleObj.order_reserve_period;

            this.form4.order_reserve_auto_establish = this.ruleObj.order_reserve_auto_establish;

            this.form5.order_reserve_expire = this.ruleObj.order_reserve_expire;

            this.form6.global_service_charge = this.ruleObj.global_service_charge;
            this.form6.global_service_charge_100 = this.ruleObj.global_service_charge_100;

            this.form7.supplier_first_update_item_price = this.ruleObj.supplier_first_update_item_price;
            this.form7.supplier_update_item_price = this.ruleObj.supplier_update_item_price;
          }
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
        });
    },

    // 获取单个配置
    getSingConfig(configKey) {
      ajaxPost("/config/getConfigKey", {
        configName: configKey
      }).then(res => {
        if (res.errorCode == 200) {
          this.ruleObj[res.data.config_name] = res.data.config_value;
          if (configKey == "global_service_charge") {
            this.ruleObj["global_service_charge_100"] = accMul(
              res.data.config_value,
              100
            );

            // 全局配置的服务费更新
            let rate = +res.data.config_value
            this.$sysConfig.globalServiceCharge = rate
            this.$sysConfig.globalServiceChargePercent = NP.times(100, rate) + '%'
          }
          if (configKey == "order_auto_establish_rules") {
            let order_auto_establish_rules = res.data.config_value.split("#");
            this.order_auto_establish_rules = order_auto_establish_rules.map(
              item => {
                return item.split(",");
              }
            );
          }
        }
      });
    },

    // 提交
    submitForm1() {
      console.log(this.form1);
      // this.pop1 = false;

      if (!this.form1.dealer_bill_start_date) {
        return this.$message.error("请选择日期");
      }

      if (this.form1.dealer_bill_interval == "") {
        return this.$message.error("请输入间隔天数");
      }

      if (!validateNumber(this.form1.dealer_bill_interval)) {
        return this.$message.error("间隔天数必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      Promise.all([
        ajaxPost("config/editConfig", {
          configName: "dealer_bill_start_date",
          configValue: this.form1.dealer_bill_start_date
        }),
        ajaxPost("config/editConfig", {
          configName: "dealer_bill_interval",
          configValue: this.form1.dealer_bill_interval
        })
      ])
        .then(values => {
          loading.close();
          let [res1, res2] = values;
          console.log(res1, res2);
          if (res1.errorCode == 200 && res2.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("dealer_bill_start_date");
            this.getSingConfig("dealer_bill_interval");
            this.pop1 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm2() {
      console.log(this.form2);
      if (this.form2.supplier_transfer_interval == "") {
        return this.$message.error("请输入间隔天数");
      }
      if (!validateNumber(this.form2.supplier_transfer_interval)) {
        return this.$message.error("间隔天数必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      ajaxPost("config/editConfig", {
        configName: "supplier_transfer_interval",
        configValue: this.form2.supplier_transfer_interval
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("supplier_transfer_interval");
            this.pop2 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm3() {
      console.log(this.form3);
      if (this.form3.order_reserve_period == "") {
        return this.$message.error("请输入小时数");
      }
      if (!validateNumber(this.form3.order_reserve_period)) {
        return this.$message.error("小时数必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      ajaxPost("config/editConfig", {
        configName: "order_reserve_period",
        configValue: this.form3.order_reserve_period
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("order_reserve_period");
            this.pop3 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm4() {
      console.log(this.form4);
      if (this.form4.order_reserve_auto_establish == "") {
        return this.$message.error("请输入比例");
      }
      if (!validateNumber(this.form4.order_reserve_auto_establish)) {
        return this.$message.error("比例必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      ajaxPost("config/editConfig", {
        configName: "order_reserve_auto_establish",
        configValue: this.form4.order_reserve_auto_establish
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("order_reserve_auto_establish");
            this.pop4 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm5() {
      console.log(this.form5);
      if (this.form5.order_reserve_expire == "") {
        return this.$message.error("请输入天数");
      }
      if (!validateNumber(this.form5.order_reserve_expire)) {
        return this.$message.error("天数必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      ajaxPost("config/editConfig", {
        configName: "order_reserve_expire",
        configValue: this.form5.order_reserve_expire
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("order_reserve_expire");
            this.pop5 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm6() {
      console.log(this.form6);
      if (this.form6.global_service_charge_100 == "") {
        return this.$message.error("请输入比例");
      }
      if (!validateNumber(this.form6.global_service_charge_100)) {
        return this.$message.error("比例必须为正整数");
      }

      this.form6.global_service_charge =
        this.form6.global_service_charge_100 / 100;

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      ajaxPost("config/editConfig", {
        configName: "global_service_charge",
        configValue: this.form6.global_service_charge
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("global_service_charge");
            this.pop6 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },

    // 提交
    submitForm7() {
      console.log(this.form7);
      if (this.form7.supplier_first_update_item_price == "") {
        return this.$message.error("请输入天数");
      }
      if (!validateNumber(this.form7.supplier_first_update_item_price)) {
        return this.$message.error("天数必须为正整数");
      }
      if (this.form7.supplier_update_item_price == "") {
        return this.$message.error("请输入天数");
      }
      if (!validateNumber(this.form7.supplier_update_item_price)) {
        return this.$message.error("天数必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      Promise.all([
        ajaxPost("config/editConfig", {
          configName: "supplier_first_update_item_price",
          configValue: this.form7.supplier_first_update_item_price
        }),
        ajaxPost("config/editConfig", {
          configName: "supplier_update_item_price",
          configValue: this.form7.supplier_update_item_price
        })
      ])
        .then(values => {
          loading.close();
          let [res1, res2] = values;
          console.log(res1, res2);
          if (res1.errorCode == 200 && res2.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("supplier_first_update_item_price");
            this.getSingConfig("supplier_update_item_price");
            this.pop7 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },


    // 新增
    add8(item, index) {
      this.pop8 = true;
      this.form8.days = '';
      this.form8.rate = '';
      this.form8.type = 1;
      this.form8.index = '';
    },
    // 编辑
    edit8(item, index) {
      this.pop8 = true;
      this.form8.days = item[0];
      this.form8.rate = item[1];
      this.form8.type = 2;
      this.form8.index = index;
    },
    // 删除
    del8(item, index) {
      console.log(index)
      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let configValue = "";
      let order_auto_establish_rules = [...this.order_auto_establish_rules]
      order_auto_establish_rules.splice(index, 1)
      configValue = order_auto_establish_rules
        .map(v => v.join(","))
        .join("#");

      ajaxPost("config/editConfig", {
        configName: "order_auto_establish_rules",
        configValue: configValue
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("删除成功");
            this.getSingConfig("order_auto_establish_rules");
            this.pop8 = false;
          } else {
            this.$message.error("删除异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },


    // 提交
    submitForm8() {
      console.log(this.form8);
      if (this.form8.days == "") {
        return this.$message.error("请输入天数");
      }
      if (!validateNumber(this.form8.days)) {
        return this.$message.error("天数必须为正整数");
      }

      if (this.form8.rate == "") {
        return this.$message.error("请输入比例");
      }
      if (!validateNumber(this.form8.rate)) {
        return this.$message.error("比例必须为正整数");
      }

      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let configValue = "";
      let order_auto_establish_rules = [...this.order_auto_establish_rules];
      if (this.form8.type == 1) {
        order_auto_establish_rules.push([
          this.form8.days,
          this.form8.rate
        ])
      }

      if (this.form8.type == 2) {
        order_auto_establish_rules[this.form8.index] = [
          this.form8.days,
          this.form8.rate
        ];
      }

      configValue = order_auto_establish_rules
        .map(v => v.join(","))
        .join("#");

      ajaxPost("config/editConfig", {
        configName: "order_auto_establish_rules",
        configValue: configValue
      })
        .then(res => {
          loading.close();
          if (res.errorCode == 200) {
            this.$message.success("修改配置成功");
            this.getSingConfig("order_auto_establish_rules");
            this.pop8 = false;
          } else {
            this.$message.error("修改配置异常");
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.rule-wrap {
  padding: 0 20px 60px;
}
.rule-sec-tit {
  font-size: 20px;
  color: #333;
  line-height: 1;
  padding: 20px 0;
  position: relative;
  width: 988px;
  .rightBtn{position: absolute;top:0;right:0px;}
}
.rule-sec-wrap {
  padding: 24px;
  background: #fff;
  width: 940px;
}
.rule-item-wrap {
  padding-bottom: 24px;
  border-bottom: 1px solid #eee;
  margin-bottom: 24px;
  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
    margin-bottom: 0;
  }
}

.rule-item-tit {
  font-size: 16px;
  color: #666;
  font-weight: bold;
  line-height: 1;
  padding-bottom: 16px;
  position: relative;
  .small {
    color: #666;
    font-weight: normal;
    font-size: 12px;
  }
  .edit-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.rule-item-content {
  width: 800px;
  text-align: justify;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  line-height: 2.6;
  .light {
    padding: 4px 10px;
    margin: 0 6px;
    background-color: #f0f9eb;
    color: #67c23a;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
  }
}
.rule-sec-wrap.mul {
  margin-top: 24px;
  .rule-item-content {
    width: 940px;
    line-height: 3.2;
  }
  .line {
    margin-right: 24px;
  }
  .add-btn {
    padding: 16px 0;
  }
}

.dialog-from-wrap {
  padding: 30px 0;
  line-height: 3.2;
}
.ipt-date {
  width: 160px;
}
.ipt-number {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/rule/list.vue